<template>
  <div id="app" v-loading.fullscreen.lock="!$teras.appReady">
    
    <site-header></site-header>

    <div v-if="$teras.appReady" class="container" style="background: #ffffff;padding:62px 20px 0 20px;">
      <div class="evento-title yo-color-primary">{{$teras.bvent.titolo}}: ABSTRACT</div>
    </div>
    <!--
    <site-navbar v-if="!(['savethedate'].indexOf($route.name) > -1)"></site-navbar>
    -->
    <div v-if="$teras.appReady" class="row container" style="background: #ffffff;padding:0 20px 60px 20px;" >
      <div id="main" class="col s12" >
        <router-view name="main"></router-view>

        <h4 v-if="$teras.chiuso">Siamo spiacenti il gestionale è chiuso. </h4>
        <h4 v-if="$teras.noabstract">Abstract non trovato.</h4>
        <h4 v-if="$teras.noevento">Evento non trovato.</h4>
        


      </div><!-- end main -->
    </div><!-- end container -->
    
    <site-footer v-if="$teras.appReady"></site-footer>
  
  </div> <!-- end app -->
</template>

<script>
import siteHeader from './components/Site-header.vue'
import siteFooter from './components/Site-footer.vue'



export default {
  name: 'app',
  components: {
    siteHeader,
    siteFooter
  }
}
</script>

<style>
#app {

}#main{

  padding:30px 0 0 0;
}.evento-title{
  font-size: 2.0rem;

  
  
}
</style>



// WEBPACK FOOTER //
// App.vue?625bdba9